import { message } from "antd";
import { useEffect } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { url } from "../../constant/url";

export default function Sso() {
    const history = useHistory();

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const token = params.get("token");

        if (!token) {
            message.error("Token SSO tidak valid");
            history.replace("/login");
            return;
        }

        localStorage.setItem("token", token);

        fetch(`${url}/getSsoData/${token}`)
            .then((res) => {
                if (!res.ok) throw new Error("SSO data fetch failed");
                return res.json();
            })
            .then((data) => {
                localStorage.setItem("fullname", data.fullname);
                localStorage.setItem("photo", data.photo);
                localStorage.setItem("menus", data.menus);
                localStorage.setItem("permissions", data.permissions);
                localStorage.setItem("active", data.active);

                message.success("Anda berhasil login via SSO");
                history.replace(data.redirect || "/dashboard");
            })
            .catch(() => {
                message.error("Gagal ambil data user");
                history.replace("/login");
            });
    }, [history]);

    return null;
}